import React, {memo, useEffect, useState} from "react";
import moment from "moment";
import ScrollArea from "react-scrollbar";
import {Icon, Input, Paper} from "@material-ui/core";
import Loading from "../../components/Loading";
import ServicesTable from "../../pages/User/ClientServices/Table";
import {useAuth} from "../../hooks/auth.hook";
import {useRequest} from "../../hooks/request.hook";
import {useConfirm} from "../../hooks/confirm.hook";


const Services = () => {
    const [loading, setLoading] = useState(true);
    const [services, setServices] = useState([]);
    const [count, setCount] = useState(0);
    const [needRequest, setNeedRequest] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [selectedServices, setSelectedServices] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState({
        direction: 'desc',
        id: 'session_date',
        sortId: 1
    });
    const {request} = useRequest();
    const {confirm} = useConfirm();
    const {user} = useAuth();

    useEffect(() => {
        if(needRequest && user && user.user_type === 2) {
            setLoading(true);

            request({url: ` /api/client/serviceregistration/registrations?element_start=${page*rowsPerPage+1}&element_count=${rowsPerPage}&sort_field=${order.sortId}&sort_direction_type=${order.direction === 'desc' ? 1 : 2}&search_text=${searchText}`})
                .then(data => {
                    if(data) {
                        setServices(data.registrations);
                        setCount(data.registration_count);
                    }

                    setNeedRequest(false);
                    setLoading(false);
                });
        }
    }, [needRequest, request, user, rowsPerPage, page, order, searchText]);

    const handleSearch = e => {
        setSearchText(e.target.value);
        if(page) setPage(0);
        if(selectedServices.length) setSelectedServices([]);
        setNeedRequest(true);
    };

    const handleSelect = service => {
        let newSelected = [...selectedServices];

        if(newSelected.find(item => item.id === service.id)) {
            newSelected = newSelected.filter(item => item.id !== service.id);
        } else if(moment().isBefore(service.session_date) && service.status_id !== 8) {
            newSelected.push(service);
        }

        setSelectedServices(newSelected);
    };

    const handleSelectAll = e => {
        if(e.target.checked) {
            setSelectedServices([
                ...selectedServices,
                ...services.filter(service => moment().isBefore(service.session_date) && service.status_id !== 8)
            ]);
        } else {
            setSelectedServices([]);
        }
    };

    const handleSort = (cellId, cellSortId) => {
        let direction = 'desc';

        if (order.id === cellId && order.direction === 'desc') {
            direction = 'asc';
        }

        setOrder({
            direction,
            id: cellId,
            sortId: cellSortId
        });

        setNeedRequest(true);
    };

    const handleChangePage = (e, value) => {
        setPage(value);
        setNeedRequest(true);
    };

    const handleChangeRowsPerPage = e => {
        setRowsPerPage(e.target.value);
        if(page) setPage(0);
        setNeedRequest(true);
    };

    const cancelRequest = async servicesIds => {
        const title = 'Отмена записи';
        const confirmation = `Вы действительно хотите отменить запись на ${services.length > 1 ? 'выбранные услуги' : 'выбранную услугу'}?`;

        if(await confirm(confirmation, title)) {
            await request({
                url: '/api/client/serviceregistration/reject_register_session',
                method: 'PUT',
                data: {
                    ids: servicesIds
                }
            });

            setSelectedServices([]);
            setNeedRequest(true);
        }
    };

    const handleCancelServices = async () => {
        const availableSelectedServices = selectedServices.filter(service => moment().isBefore(service.session_date) && service.status_id !== 8);

        if(availableSelectedServices.length) {
            await cancelRequest(availableSelectedServices.map(service => service.id));
        } else {
            setNeedRequest(true);
        }
    };

    const handleCancelService = async id => {
        const availableServicesIds = services.filter(service => moment().isBefore(service.session_date)).map(service => service.id);

        if(availableServicesIds.includes(id)) {
            await cancelRequest([id]);
        } else {
            setNeedRequest(true);
        }
    };

    return (
        <div className="registration-for-service__services services">
            <ScrollArea
                className="services__wrap-scroll"
                contentClassName="services__scroll"
                verticalScrollbarStyle={{borderRadius: 6, width: 6, backgroundColor: '#aaa'}}
                verticalContainerStyle={{borderRadius: 8, width: 8}}
                horizontal={false}
                smoothScrolling={true}
            >
                <h2 className="services__title">Расписание</h2>
                <Paper className="services__search">
                    <Icon className="services__search-icon">search</Icon>
                    <Input
                        placeholder="Поиск"
                        className="services__search-input"
                        disableUnderline
                        fullWidth
                        value={searchText}
                        onChange={handleSearch}
                    />
                </Paper>
                {loading ?
                    <Loading centered={false}/> :
                    services.length ?
                        <ServicesTable
                            mobile
                            services={services}
                            selectedServices={selectedServices}
                            order={order}
                            count={count}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onSelect={handleSelect}
                            onSelectAll={handleSelectAll}
                            onCancelServices={handleCancelServices}
                            onCancelService={handleCancelService}
                            onSort={handleSort}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        /> :
                        <div className="services__not-found">
                            <h4>{searchText ? 'Записей не найдено' : 'У Вас нет записей'}</h4>
                        </div>
                }
            </ScrollArea>
        </div>
    )
};

export default memo(Services);